module.exports = "pegasus/assets/tech/realty/102.png";